import { render, staticRenderFns } from "./profit-statisrics-task.vue?vue&type=template&id=4b0b0712&scoped=true&"
import script from "./profit-statisrics-task.vue?vue&type=script&lang=js&"
export * from "./profit-statisrics-task.vue?vue&type=script&lang=js&"
import style0 from "./profit-statisrics-task.vue?vue&type=style&index=0&id=4b0b0712&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b0b0712",
  null
  
)

export default component.exports